import React__default from 'react';
import { TableCore } from '../shared/components/Table.mjs';
import { TableActions } from './TableActions.mjs';
import { Typography } from './Typography.mjs';
import tableCellClasses from '../../../../../node_modules/@mui/material/TableCell/tableCellClasses.mjs';

const tableCellSx = {
    borderBottomColor: (theme)=>theme.styleConfig.colors.subtle,
    color: (theme)=>theme.styleConfig.colors.primary,
    backgroundColor: (theme)=>theme.styleConfig.container.backgroundColor
};
const tableActionsCellSx = {
    minWidth: 0,
    [`&.${tableCellClasses.head}`]: {
        textAlign: 'center'
    }
};
const tableRowSxWithoutBottomBorder = {
    '&:last-child th, &:last-child td': {
        borderBottom: 0
    }
};
const expandMoreCellSx = {
    padding: (theme)=>theme.spacing(0.5, 0),
    width: (theme)=>theme.spacing(2)
};
const expandedContentContainerSx = {
    padding: (theme)=>theme.spacing(1, 2, 1, 2)
};
const Table = (props)=>{
    return /*#__PURE__*/ React__default.createElement(TableCore, {
        ...props,
        TableActionsComponent: TableActions,
        TypographyComponent: Typography,
        tableCellSx: tableCellSx,
        tableActionsCellSx: tableActionsCellSx,
        tableRowSx: props.disableBottomBorder ? tableRowSxWithoutBottomBorder : undefined,
        expandMoreCellSx: expandMoreCellSx,
        expandedContentContainerSx: expandedContentContainerSx
    });
};

export { Table };
//# sourceMappingURL=Table.mjs.map
